export const styleSheet = () => ({});
